import { TSubcategory } from '../multipleCategories'

const getInitVerticalOrder = (): Record<string, TSubcategory[]> => ({
  Synergy: [],
  Power: [],
  'Power CDR': [],
  'Power Services': [],
})

export const orderGroupedSubcategories = (
  grouped: Record<string, TSubcategory[]>,
  orderedBusinessUnits: string[]
) => {
  const orderedGroups: Record<string, TSubcategory[]> = {}
  // init orderedGroups
  orderedBusinessUnits.forEach((unit) => {
    const subcategories = grouped[unit]
    if (subcategories) {
      orderedGroups[unit] = subcategories
    }
  })
  // complete orderedGroups by maintained subcategories, if not handled
  Object.keys(grouped).forEach((unit) => {
    const subcategories = grouped[unit]
    if (!orderedGroups[unit]) {
      orderedGroups[unit] = subcategories
    }
  })

  // order subcategories in groups
  Object.keys(orderedGroups).forEach((unit) => {
    orderedGroups[unit] = orderSubcategories(orderedGroups[unit])
  })

  return orderedGroups
}

export const orderSubcategories = (subcategories: TSubcategory[]) => {
  const orderedSubcategories: TSubcategory[] = []

  const orderedCodes: Record<string, boolean> = {}
  const verticalOrder = getInitVerticalOrder()
  // save codes, which can be ordered
  Object.keys(verticalOrder).forEach((entry) => {
    subcategories.forEach((subcategory) => {
      if (subcategory.title.endsWith(entry)) {
        verticalOrder[entry].push(subcategory)
        orderedCodes[subcategory.guid] = true
      }
    })
  })
  Object.values(verticalOrder).forEach((items) => {
    if (items.length) {
      orderedSubcategories.push(...items)
    }
  })

  // complete by codes, which can not be ordered
  subcategories.forEach((subcategory) => {
    if (!orderedCodes[subcategory.guid]) {
      orderedSubcategories.push(subcategory)
    }
  })

  return orderedSubcategories
}
